import HeroBannerBody from './HeroBannerBody';
import type { HeroBannerData, InfoItem } from './HeroBannerBody';

// Tipos re-exportados para compatibilidade com imports existentes.
export type { HeroBannerData, InfoItem };

const HeroBannerView = ({ data }: { data: HeroBannerData }) => (
  <HeroBannerBody data={data} />
);

export default HeroBannerView;
